<template>
	<CenterLayout width="100%" :height="height">
		<Empty
			:image="exclamationCircleOutlined"
			:image-style="{
				fontSize: '70px',
				color: 'rgba(0, 0, 0, 0.5)',
			}"
		>
			<template #description>
				<span :style="{ color: 'rgba(0, 0, 0, 0.5)' }">{{ $t(messageKey) }}</span>
			</template>
		</Empty>
	</CenterLayout>
</template>
<script>
import { h } from 'vue';
import { Empty } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';

import CenterLayout from '@/components/common/CenterLayout.vue';

export default {
	components: {
		Empty,
		CenterLayout,
	},
	props: {
		messageKey: {
			type: String,
			required: true,
		},
		height: {
			type: String,
			default: '500px',
		},
	},
	setup() {
		return {
			exclamationCircleOutlined: h(ExclamationCircleOutlined),
		}
	},
}
</script>